import angular from 'angular';
import searchComponent from './adverse-event-search.component';
import './adverse-event-search.scss';

export default angular.module('components.app.adverseEvents.adverseEventSearch', [])
  .component('adverseEventSearch', searchComponent)
  .value('EventEmitter', payload => ({ $event: payload }))
  .name;



// WEBPACK FOOTER //
// ./components/app/adverse-events/adverse-event-search/adverse-event-search.module.js